export enum OrderStatus { // TODO use number
    CREATED = '1',
    PAID = '2',
    DELETED = '3',
}

export interface HistoryOrder {
    id: number;
    invNum: string;
    expand: boolean;
    desc: string;
    doc_act: string;
    doc_invoice: string;
    created_at: string;
    sum: number;
    status: OrderStatus;

    email: string;
    phone: string;

    items: Array<{
        license: number;
        name: string;
        name_short?: string;
        price: number;
        qnt: number;
        total: number;
    }>;
}

export const initialHistoryOrder: Readonly<HistoryOrder> = {
    expand: false,
    id: 0,
    invNum: '0',
    desc: '',
    doc_act: '',
    doc_invoice: '',
    created_at: '',
    sum: 0,
    status: OrderStatus.CREATED,

    email: '',
    phone: '',
    items: [],
};
